import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-pcomp-data-table',
	templateUrl:'./DataTablePluginCompPage.html',
	styles: [],
	styleUrls:['./DataTablePluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class DataTablePluginCompPage
{
	mdContent_895 = `\`\`\`java
import com.jwebmp.plugins.datatable.DataTable;
\`\`\``;
	mdContent_896 = `\`\`\`java
DataTable()
\`\`\``;
	mdContent_897 = `\`\`\`java
DataTable&lt;?&gt; table = new DataTable&lt;&gt;();
table.getOptions()
     .setPaging(true)
     .setSearching(true)
     .setOrdering(true)
     .setInfo(true);
\`\`\``;
}
